import script from "./AiModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiModal.vue?vue&type=script&lang=ts&setup=true"

import "./AiModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__